import axios from "axios";
import {snakeCase} from "../utils/snake_case";


export const createIncidentAttachment = async (incident_id, data) => {
    const formData = new FormData();
    const dataSnakeCase = snakeCase(data);
    for (const key in dataSnakeCase) {
        if (dataSnakeCase[key] !== undefined && dataSnakeCase[key] !== null) {
            formData.append(key, dataSnakeCase[key]);
        }
    }
    const res = await axios.post(`/api/v1/incidents/${incident_id}/attachments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return res.data;
}

export const updateIncidentAttachment = async (incident_id, attachment_id, data) => {
    const formData = new FormData();
    const dataSnakeCase = snakeCase(data);
    for (const key in dataSnakeCase) {
        if (dataSnakeCase[key] !== undefined && dataSnakeCase[key] !== null) {
            formData.append(key, dataSnakeCase[key]);
        }
    }
    const res = await axios.put(`/api/v1/incidents/${incident_id}/attachments/${attachment_id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return res.data;
}

export const deleteIncidentAttachment = async (incident_id, attachment_id) => {
    const res = await axios.delete(`/api/v1/incidents/${incident_id}/attachments/${attachment_id}`);

    return res.data;
}